import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Podcast } from './types'

export const CREATE_PODCAST: TypedDocumentNode<
  { createPodcast: Podcast },
  {
    client_id: string
    application_id: string
    name: string
    embedded_link?: string | null
    description?: string | null
    observations?: string | null
  }
> = gql`
  mutation CreatePodcast($client_id: ID!, $application_id: ID!, $name: String!, $embedded_link: String, $description: String, $observations: String) {
    createPodcast(client_id: $client_id, application_id: $application_id, name: $name, embedded_link: $embedded_link, description: $description, observations: $observations) {
      id client_id application_id name embedded_link description observations synchronized_at created_at updated_at
    }
  }
`

export const UPDATE_PODCAST: TypedDocumentNode<
  { updatePodcast: Podcast },
  {
    id: string
    name?: string
    embedded_link?: string | null
    description?: string | null
    observations?: string | null
  }
> = gql`
  mutation UpdatePodcast($id: ID!, $name: String, $embedded_link: String, $description: String, $observations: String) {
    updatePodcast(id: $id, name: $name, embedded_link: $embedded_link, description: $description, observations: $observations) {
      id client_id application_id name embedded_link description observations synchronized_at created_at updated_at
    }
  }
`

export const DELETE_PODCAST: TypedDocumentNode<{ deletePodcast: boolean }, { id: string }> = gql`
  mutation DeletePodcast($id: ID!) {
    deletePodcast(id: $id)
  }
`
